export const eliteDealsAssets = {
	buttonBackground: "/spec_elite_deals/button-bg.jpg",
	boxBackground: "/spec_elite_deals/box/bg.gif"
} as const;
